import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";

// Timeseries Call - seven
export const fetchActiveTimeseriesForAlarmList = (
  sourceId,
  signal?: AbortSignal,
) => {
  const url = `${appUrl()}/api/get-active-timeseries-by-data-source`;

  const result = fetch(url, {
    method: "POST",
    headers: buildAuthenticationHeaders(),
    body: JSON.stringify({
      ...buildAuthenticationBody(),
      source_id: sourceId,
    }),
    signal,
  })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else if (res.status === 404 || res.status === 422) {
        return {};
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    })
    .then((data) => {
      if (data !== undefined) {
        return data;
      }
    })
    .catch((err) => {
      if (signal?.aborted) return;
      else if (err instanceof TokensExpiredError) {
        console.log("error: ", err);
      } else if (err instanceof DOMException) {
        return;
      } else {
        console.log("generic error", err);
      }
    });

  return result;
};
